export interface FacebookAdError {
  title: string;
  message: string;
  details: string;
}

export const exampleFacebookAdError: FacebookAdError = {
  title: 'Incorrect Permissions',
  message: 'Your ad account has incorrect permissions',
  details:
    'Make sure to confront our docs and that all of the correct fields are updated',
};
